<template>
  <div
    :disabled="isDisabled"
    class="item item-with-icon"
    :class="{ 'disabled': isDisabled }"
    @click="duplicate"
  >
    <base-icon icon-name="copy" iconColor="#8c8c8c" />
    <span class="no-child">Duplicate</span>
  </div>
</template>

<script>
import saveWorkflow from '@/components/workflow/mixins/saveWorkflow';
import callToApiBackend from '@/components/workflow/mixins/callToApiBackend';
import OptionModal from "./option-modal";
import { showGlobalBanner } from '@/services/global-banner.js';
export default {
  name: "MoreOptionsDuplicate",
  components: { OptionModal },
  mixins: [ saveWorkflow, callToApiBackend ],
  props: {
    currentWorkflow: { type: Object }
  },
  inject: ['getMyWorkflows'],
  data() {
    return {
      isDisabled: false,
    }
  },
  methods: {
    addWorkflow(wf) {
      this.$store.commit('addWorkflow', wf);
    },
    duplicate() {
      const workflowNew = {
        ...this.currentWorkflow,
        id: '',
        publication_id: this.$store.state.hcube.publication_id,
      };
      this.isDisabled = true;
      this.updateSingleWorkflowAPI('post', null, workflowNew)
        .then((d) => {
          const wf = {
            ...d,
            data: d.document,
          }
          this.$snackbar({title: 'Experiment duplicated.', btn: null, duration: 6000});
          if(this.getMyWorkflows) this.getMyWorkflows();
          else this.addWorkflow(wf);
        })
        .catch((err) => {
          let title = '';
          let body = '';
          const msg = err.response?.data?.msg;
          if(msg === 'Could not validate json with experiment') {
            title = 'Selected experiment could not be duplicated.';
            body = 'Due to technical reasons, we were unable to duplicate this experiment. Please create a new one..';
          }
          else {
            title = 'Experiment could not be duplicated.';
            body = 'Due to technical reasons, we were unable to duplicate this experiment. Please try again.';
          }
          showGlobalBanner(this, {
            title,
            body,
            btn: 'dismiss',
          });
        })
        .finally(() => {
          this.isDisabled = false;
        })
    }
  },
}
</script>
<style lang="scss" scoped>
.item {
  font-weight: 400;
	font-style: normal;
	font-size: 16px;
	white-space: pre-line;

  &.item-with-icon .icons {
  	margin-right: 23px;
  }
}

</style>
